import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '../modules/auth/services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService, private authService: AuthService, private router: Router) {
  }

  handle401Error(req: HttpRequest<any>, next: HttpHandler, error): Observable<HttpEvent<any>> {

    return this.authService.tryToUseRefreshToken().pipe(
      switchMap(() => {
        return next.handle(req);
      }),
      catchError(() => {
        this.authService.logout().then(() => {
          this.router.navigate(['/login']);
        });

        return throwError(error);
      })
    );
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        switch (err.status) {
          case 0:
            if (!request.params.get('_preventToast')) {
              this.toastr.error('The network connection was lost. Please try again.', 'Error');
            }
            return throwError(() => err);
          case 401:
          case 504:
          case 502:
            break;
          case 404:
          case 500:
          default:
            let body = request.body;
  
            if (request.params.get('_preventToast')) {
              return;
            }
            
            if (body) {
              if (typeof body === 'string') {
                const pairs = body.slice(1).split('&'),
                  result = {};

                pairs.forEach(function(pair) {
                  const p = pair.split('=');
                  result[p[0]] = decodeURIComponent(p[1] || '');
                });

                body = JSON.parse(JSON.stringify(result));
              }
              
              if (body && typeof body === 'object' && body._preventToast) {
                return;
              }
            }
            
            if (err.error && err.error['Message']) {
              this.toastr.error(err.error['Message']);
            } else if (err.error && err.error['message']) {
              this.toastr.error(err.error['message']);
            } else {
              this.toastr.error(err.message);
            }
            console.log("interceptor", err);
        }
      }
    }),
      catchError((err, caught) => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          return this.handle401Error(request, next, err);
        }

        if (err instanceof HttpErrorResponse && err.status === 500 || err instanceof HttpErrorResponse && err.status === 406) {
          return throwError(err);
        }
      })
    );
  }
}
